import { render, staticRenderFns } from "./Flashbox.vue?vue&type=template&id=5169a4fa&scoped=true"
import script from "./Flashbox.vue?vue&type=script&lang=js"
export * from "./Flashbox.vue?vue&type=script&lang=js"
import style0 from "./Flashbox.vue?vue&type=style&index=0&id=5169a4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169a4fa",
  null
  
)

export default component.exports